import React from "react";
import { HashRouter, Route, Routes, useLocation } from "react-router-dom";
import ABBLogin from "./pages/login/login";
import Signup from "./pages/signup/signup";
import RatingenInit from "../src/pages/Dashboard/index"
import Navbar from "./components/Navbar/navbar";
// import ChangePassword from "./pages/change-password/change-passoword";
// import ForgotPassword from "./pages/forgot-password/forgot-password";
// Component to conditionally render navbar
function AppLayout() {
  const location = useLocation();

  // Define routes where navbar should be shown
  const navbarRoutes = [
    '/settings',
    '/substation-explorer',
    '/substation-dashboard',
    '/sld-preview',
    '/edit-user'
  ];

  // Check if current path matches any navbar route
  const shouldShowNavbar = navbarRoutes.some(route =>
    location.pathname.startsWith(route)
  );

  return (
    <>
      {shouldShowNavbar && (
        <>
          <Navbar />
          {/* <CognienNavbar /> */}

        </>

      )}
      <Routes>
        <Route exact path="/" element={<ABBLogin />} />
        <Route path="#/" element={<ABBLogin />} />
        <Route path="/ratingen" element={<RatingenInit />} />
        <Route exact path="/signup" element={<Signup />} />
          {/* <Route path="/change-password" element={<ChangePassword />} />
        <Route path="/forgot-password" element={<ForgotPassword />} /> */}
      </Routes>
    </>
  );
}

function CogniENRoutes() {
  return (
    <HashRouter>
      <AppLayout />
    </HashRouter>
  );
}

// Make sure to export as default
export default CogniENRoutes;